import React from "react";
import "../Styles/ContactCard.css";

const ContactCard = ({ icon: Icon, heading, subtext }) => {
  return (
    <div className="contact-card">
      <div className="icon-box">
        <Icon className="contact-icon" />
      </div>
      <div className="text-box">
        <h4>{heading}</h4>
        {subtext.split("\n").map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>
    </div>
  );
};

export default ContactCard;
